import { PropsWithChildren, Children, isValidElement, ReactNode } from "react";
import { OptionProps, Option } from "../Option";

/**
 * Gets the options from the specified children.
 * @param children The children to get the options from.
 * @returns The array of options.
 */
export function getOptions(children: ReactNode | undefined): ReadonlyArray<PropsWithChildren<OptionProps>> {
  return (
    Children.map(children, (child) => {
      if (!isValidElement(child)) return null;

      if (child.type === Option) {
        return child.props;
      }

      console.log("CheckboxGroup.Group ignoring unsupported child component.");
      return null;
    })?.filter((option) => !!option) ?? []
  );
}
